import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import { getDisasters } from "../../../../api";
import type { DisasterItem, DisasterSelectValue } from "../../../../types/disaster";

type JoinDisasterSelectProps = {
  changedValue: (value: DisasterSelectValue) => void;
  ownId: string | null;
};

export default function JoinDisasterSelect({
  changedValue,
  ownId,
}: JoinDisasterSelectProps) {
  const [disasters, setDisasters] = useState<DisasterItem[]>([]);

  const fetchDisasters = async () => {
    try {
      const response = await getDisasters({
        name: null,
        is_completed: false,
        exclude_id: ownId,
        start_at_stt: null,
        start_at_end: null,
        order: null,
        sort: null,
        page: 1,
        limit: null,
      });
      if (response.status !== "ok") {
        return;
      }
      const data = response.disasters;
      if (data) {
        setDisasters(data);
      } else {
        console.error("ヒットするSSなし");
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    fetchDisasters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={disasters}
      getOptionLabel={(disaster) => disaster.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField {...params} label="結合先災害選択" name="joinDisasterSelect" />
      )}
      onChange={(_event, newValues) => {
        changedValue({ id: newValues?.id, name: newValues?.name });
      }}
    />
  );
}
